import React from "react";
import { TextField } from "../../../../../ui/components/TextField";
import { FieldFootnote } from "./FieldFootnote";
import { FieldRowProps } from "./fieldTypes";

/** A single-line text field. */
export const TextFieldRow: React.FC<FieldRowProps> = ({
  config,
  value,
  locked,
  lockReason,
  errorMessage,
  onChange,
}) => (
  <div className="flex w-full flex-col gap-1">
    <TextField
      className="w-full"
      label={config.label}
      disabled={locked}
      error={Boolean(errorMessage)}
    >
      <TextField.Input
        value={value}
        placeholder={config.placeholder}
        disabled={locked}
        onChange={(event: React.ChangeEvent<HTMLInputElement>) => onChange(event.target.value)}
      />
    </TextField>

    <FieldFootnote
      hint={config.hint}
      example={config.example}
      lockReason={lockReason}
      errorMessage={errorMessage}
    />
  </div>
);
